import {Component, inject, LOCALE_ID, OnDestroy, OnInit} from '@angular/core';
import {AppService} from '../app.service';
import {Subscription} from 'rxjs';
import {Diskusia} from '../model/diskusia';
import {PodporaDetailComponent} from '../podpora-detail/podpora-detail.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
    selector: 'app-diskusia',
    templateUrl: './diskusia.component.html',
    styleUrls: ['./diskusia.component.css'],
    standalone: false
})
export class DiskusiaComponent implements OnInit, OnDestroy
{
    private locale = inject(LOCALE_ID);


  data: Diskusia[];
  diskusiaData: Subscription;
  count = 0;

  constructor(
      private appService: AppService,
      private dialogService: MatDialog
  ) { }

  ngOnInit() {
    this.diskusiaData = this.appService.diskusiaData
      .subscribe((data: Diskusia[]) => {
        this.data = data;
        data.forEach((i: Diskusia) => {
          this.count += i.pocet;
        });
      });

    this.appService.fetchDiskusia();
  }

  ngOnDestroy(): void {
    this.diskusiaData.unsubscribe();
  }

    diskusiaOpen(d: Diskusia)
    {
        const dialogRef =
          this.dialogService.open(
            PodporaDetailComponent, {
              maxHeight: '90vh',
              width: '800px',
              data: {
                diskusia: d
              }
            }
          );
    }

    protected getDiskusiaUrl(d: Diskusia) {
        return '/ais/apps/podpora/' + this.locale + /diskusia/ + d.id;
    }
}
